export type LabTheme = 'light' | 'dark';

const STORAGE_KEY = 'web-studio-design-lab-theme';

export function getStoredLabTheme(): LabTheme | null {
  if (typeof window === 'undefined') return null;
  const value = localStorage.getItem(STORAGE_KEY);
  return value === 'light' || value === 'dark' ? value : null;
}

export function resolveInitialLabTheme(): LabTheme {
  const stored = getStoredLabTheme();
  if (stored) return stored;
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: light)').matches) {
    return 'light';
  }
  return 'dark';
}

export function applyLabTheme(theme: LabTheme): void {
  document.documentElement.dataset.labTheme = theme;
  localStorage.setItem(STORAGE_KEY, theme);
}

/** Call before React mount to avoid theme flash. */
export function bootstrapLabTheme(): LabTheme {
  const theme = resolveInitialLabTheme();
  document.documentElement.dataset.labTheme = theme;
  return theme;
}

export function toggleLabTheme(current: LabTheme): LabTheme {
  const next = current === 'dark' ? 'light' : 'dark';
  applyLabTheme(next);
  return next;
}
